import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChatbotSurvey } from '../ChatbotSurvey';
export function HeroSection() {
  const [showChatbot, setShowChatbot] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed nav height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <>
      <section className="relative min-h-screen flex flex-col justify-center items-center px-4 sm:px-8 md:px-[60px] py-[120px] overflow-hidden bg-gradient-to-br from-[#B5EAD7] to-[#C5F467]" style={{
      background: 'linear-gradient(135deg, #B5EAD7 0%, #C5F467 100%)'
    }} data-id="element-1052">
        <div className="max-w-[1400px] mx-auto w-full text-center" data-id="element-1053">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1054">
            <div className="inline-block mb-6" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '13px',
            fontWeight: 600,
            letterSpacing: '4px',
            color: '#0D2926'
          }} data-id="element-1055">
              RESEARCH INITIATIVE
            </div>
            <h1 className="text-[#1A3D3A] mb-8 max-w-4xl mx-auto px-4" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(36px, 8vw, 80px)',
            fontWeight: 500,
            lineHeight: 1.1,
            letterSpacing: '-2px'
          }} data-id="element-1056">
              The Science of{' '}
              <span className="block sm:inline" style={{
              color: '#0D2926'
            }} data-id="element-1057">
                Partnership Success
              </span>
            </h1>
            <p className="text-[#3D5654] max-w-[600px] mx-auto mb-12 px-4" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'clamp(16px, 4vw, 20px)',
            fontWeight: 400,
            lineHeight: 1.7
          }} data-id="element-1058">
              We study the behavioral dynamics that determine whether business
              partnerships thrive or fracture, turning relationship patterns
              into predictive insights.
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center px-4" data-id="element-1059">
              <button onClick={() => setShowChatbot(true)} className="px-[40px] py-[18px] bg-[#1A3D3A] text-white rounded hover:opacity-90 hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '1px',
              borderRadius: '4px',
              boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
            }} data-id="element-1060">
                PARTICIPATE IN RESEARCH
              </button>
              <button onClick={() => scrollToSection('problem')} className="px-[36px] py-[16px] bg-transparent text-[#1A3D3A] border-2 border-[#1A3D3A] rounded hover:bg-[#1A3D3A] hover:text-white transition-all focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '13px',
              fontWeight: 600,
              letterSpacing: '1px',
              borderRadius: '4px'
            }} data-id="element-1061">
                VIEW FINDINGS
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {showChatbot && <ChatbotSurvey onClose={() => setShowChatbot(false)} data-id="element-1062" />}
    </>;
}